import { icfDocumentRevisionUidParamName } from './trial/detail/e-consent/icf-document/routes'

export const routes = {
  trials: 'trials',
  completeDocuSign: 'complete-docusign',
  explanationRoom: 'explanation-rooms',
  icfDocumentRevisionVideoStream: `trials/:trialUid/e-consent/icf-documents/revisions/:${icfDocumentRevisionUidParamName}/video_stream`,
} as const
